// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__gK7L7","link":"HeaderSimple_link__Q5apm","inputSearch":"HeaderSimple_inputSearch__e7Yt+"};